<template>
  <ol class="list-unstyled">
    <song-block :current-track-id="currentTrackId" v-for="(song, key) in tracks" :song="song" :count="key" :key="key" @playItem="$emit('playSelectSong',key)"></song-block>
  </ol>
</template>

<script>
import SongBlock from './SongBlock'
export default {
  name: 'SongsPlaylist',
  components: {SongBlock},
  props: ['tracks', 'currentTrackId']
}
</script>

<style scoped>
</style>
